document.addEventListener('DOMContentLoaded', function () {
    var toggles = document.querySelectorAll('.nr-wpml-ls .pgut-lang-toggle');
    toggles.forEach(function (btn) {
        var submenuId = btn.getAttribute('aria-controls');
        if (!submenuId) return;
        var submenu = document.getElementById(submenuId);
        if (!submenu) return;

        // S'assure que c'est masqué par défaut (HTML met 'hidden', on renforce si besoin)
        if (!submenu.hasAttribute('hidden')) submenu.setAttribute('hidden', '');

        function open() {
            btn.setAttribute('aria-expanded', 'true');
            submenu.removeAttribute('hidden');
        }
        function close() {
            btn.setAttribute('aria-expanded', 'false');
            submenu.setAttribute('hidden', '');
        }
        function isOpen() {
            return btn.getAttribute('aria-expanded') === 'true';
        }

        // Click toggle
        btn.addEventListener('click', function (e) {
            isOpen() ? close() : open();
        });

        // Clavier sur le bouton
        btn.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                isOpen() ? close() : open();
            } else if (e.key === 'ArrowDown') {
                // Ouvre et place le focus sur le 1er lien
                open();
                var first = submenu.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
                if (first) first.focus();
            } else if (e.key === 'Escape') {
                close();
            }
        });

        // Échap depuis le sous-menu
        submenu.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                close();
                btn.focus();
            }
        });

        // Clic en dehors -> ferme
        document.addEventListener('click', function (e) {
            if (!btn.contains(e.target) && !submenu.contains(e.target)) {
                close();
            }
        });

        // Perte de focus hors bouton+submenu -> ferme
        submenu.addEventListener('focusout', function (e) {
            var next = e.relatedTarget;
            if (!next || (!submenu.contains(next) && next !== btn)) {
                close();
            }
        });
    });
});
